import React from 'react';
import './Header.css';
import WhatsAppIcon from './WhatsAppIcon';
import LanguagePicker from './LanguagePicker';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function Header() {
  const phoneNumber = '919385331477';
  const formattedPhoneNumber = '+91 93853 31477';
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <header className="Header">
      <div className="header-left">
        <LanguagePicker />
      </div>
      <div className="header-center">
        <h1>{t.siteName}</h1>
      </div>
      <div className="header-right">

        <a href={`https://wa.me/${phoneNumber}`} className="header-link whatsapp-link" target="_blank" rel="noopener noreferrer">
          <span className="icon-wrapper"><WhatsAppIcon /></span>
          <span>{formattedPhoneNumber}</span>
        </a>

      </div>
    </header>
  );
}

export default Header;





